import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'

type Props = {
  boxSize?: number
  isDark?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  props: {
    boxSize: { default: 6 },
    isDark: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const box = ref(`${props.boxSize}px`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "spinner",
    style: _normalizeStyle({
      color: 'green',
      '--box-size': `${box.value}`,
    })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["spinner-box", { 'is-dark': _ctx.isDark }])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["spinner-box", { 'is-dark': _ctx.isDark }])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["spinner-box", { 'is-dark': _ctx.isDark }])
    }, null, 2 /* CLASS */)
  ], 4 /* STYLE */))
}
}

})